var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"digibook-footer",attrs:{"id":"digibook-footer"}},[_c('div',{staticClass:"holder container"},[_c('div',{staticClass:"copyright",domProps:{"innerHTML":_vm._s(_vm.$t('front_end.common.copyright'))}}),_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":require("../../assets/images/logo-footer.png"),"alt":"logo"}})])
}]

export { render, staticRenderFns }